export default "__VITE_ASSET__dW2th_K1__"